import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { SmsSender, SmsSenderType } from '../types';

export const mockSmsSenders: SmsSender[] = [
  {
    id: 1,
    projectId: 1,
    phoneNumber: 'MGMGMGMGMGMGMGMGMGMGMGMGMGMGMGMGMG',
    espAccountId: 789,
    name: 'Iterable Messaging Service',
    type: SmsSenderType.MESSAGING_SERVICE,
  },
  {
    id: 2,
    projectId: 1,
    phoneNumber: '1234676',
    espAccountId: 4,
    name: SERVICE_PROVIDERS.TWILIO,
    type: SmsSenderType.MESSAGING_SERVICE,
    messageTypeId: 10,
  },
  {
    id: 7357,
    projectId: 1,
    phoneNumber: '144928',
    espAccountId: 7357,
    name: SERVICE_PROVIDERS.TELNYX,
    type: SmsSenderType.MESSAGING_SERVICE,
    messageTypeId: 7357,
  },
];

export const mockSmsSender: SmsSender = mockSmsSenders[0];
